import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Card, Typography, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import getDataById from "../../../hooks/admin/getDataById";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";

const { TextArea } = Input;
const { Title } = Typography;

const AdminEditPaymentMethods = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [gatewayImage, setGatewayImage] = useState(null);
  const user = JSON.parse(localStorage.getItem("admin"));
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    const fetchGateway = async () => {
      const res = await getDataById("admin/getbyidpaymentgateway", id);
      if (res.status_code === 200) {
        form.setFieldsValue({
          gateway_name: res.data.gateway_name,
          action_url: res.data.action_url,
          description: res.data.description,
        });
        setGatewayImage(res.data.gateway_image);
      }
      setLoading(false);
    };
    fetchGateway();
  }, [id]);

  const handleFinish = async (values) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("gateway_name", values.gateway_name);
    formData.append("action_url", values.action_url);
    formData.append("description", values.description);
    if (gatewayImage && typeof gatewayImage !== "string") {
      formData.append("gateway_image", gatewayImage);
    }

    const res = await fetch(
      `${process.env.REACT_APP_APIURL}/admin/updatepaymentgateway`,
      {
        method: "PATCH",
        body: formData,
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );

    const response = await res.json();
    if (response?.status_code === 200) {
      toast.success("Gateway updated successfully");
      navigate("/admin/payment-gateway");
    } else {
      toast.error("Something went wrong");
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <Card title={<Title level={4}>Edit Payment Gateway</Title>} className="max-w-2xl mx-auto">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className="space-y-4"
      >
        <Form.Item
          label="Gateway Name"
          name="gateway_name"
          rules={[{ required: true, message: "Please enter the gateway name" }]}
        >
          <Input placeholder="Enter gateway name" />
        </Form.Item>

        <Form.Item
          label="Action URL"
          name="action_url"
          rules={[{ required: true, message: "Please enter the action URL" }]}
        >
          <Input placeholder="Enter action URL" />
        </Form.Item>

        <Form.Item label="Gateway Image">
          <Upload
            beforeUpload={(file) => {
              setGatewayImage(file);
              return false;
            }}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
          {gatewayImage && typeof gatewayImage === "string" && (
            <img
              src={gatewayImage}
              alt="gateway"
              style={{ marginTop: 10, width: 80, height: 80, objectFit: "contain" }}
            />
          )}
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
        >
          <TextArea rows={4} placeholder="Enter description" />
        </Form.Item>

        <Form.Item>
          <Space>
            <Link to="/admin/payment-gateway">
              <Button danger>Cancel</Button>
            </Link>
            <button type="submit" className="btn btn-primary text-white btn-sm">
              Update
            </button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default AdminEditPaymentMethods;

